import React from "react";
import style from "css/admin/component.module.css";
import { Modal, Button, ConfigProvider } from "antd";

function AdminDeleteConfirmModal({ open, onCancel, onConfirm, loading = false, record = null }) {
    const memberId = record?.MEMBER_ID ? String(record.MEMBER_ID).trim() : "";
    const memberNm = record?.MEMBER_NM ? String(record.MEMBER_NM).trim() : "";
    const displayName = [memberId, memberNm].filter(Boolean).join(" / ");

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            closable={false}
            maskClosable={!loading}
            styles={{ content: { borderRadius: 12 }, mask: { backdropFilter: "none" } }}
            footer={
                <ConfigProvider
                    theme={{
                        token: { colorPrimary: "#f65c22" },
                        components: {
                            Button: {
                                colorPrimaryHover: "#e4561f",
                                colorPrimaryActive: "#cc4b1b",
                            },
                        },
                    }}
                >
                    <div className={style.modal_footer_wrap}>
                        <Button
                            key="cancel"
                            onClick={onCancel}
                            disabled={loading}
                            className={style.modal_footer_btn}
                        >
                            취소
                        </Button>
                        <Button
                            key="submit"
                            type="primary"
                            onClick={onConfirm}
                            loading={loading}
                            className={style.modal_footer_btn}
                        >
                            삭제
                        </Button>
                    </div>
                </ConfigProvider>
            }
            centered
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, paddingTop: 6 }}>
                <div className={style.searchItem_label} style={{ fontSize: 16, textAlign: "center" }}>
                    {displayName || "-"}
                </div>
                <div className={style.searchItem_label} style={{ fontSize: 15, fontWeight: 500, textAlign: "center" }}>
                    관리자를 삭제하시겠습니까?
                </div>
            </div>
        </Modal>
    );
}

export default AdminDeleteConfirmModal;
